import { UserType } from "../types/enums";

const credentials = JSON.parse(localStorage.getItem("credentials"));

const isEmployee =
  credentials &&
  credentials.user &&
  credentials.user.type === UserType.EMPLOYEE;

export default isEmployee;



// WEBPACK FOOTER //
// ./src/utils/is-employee.js